import {
    orgBookings,
    orgBookingsCount,
    orgDashboard,
    orgDashboardCount,
    supOrgDashboardData,
    supOrgTripDashStats
} from '../../../api/supportAdmin';
import errorHandle from '../../../utils/errorHandle';

export const getTableData = (orgId, selected, setTableData, limit, offset, setLoading, bookingsOnly) => {
    setLoading(true);
    try {
        orgDashboard(orgId, selected, limit, offset, bookingsOnly).then((item) => {
            const data = item.data.map((item) => {
                return {
                    _id: item._id,
                    name: item?.contentId?.title ?? 'N/A',
                    startDate: item?.startDate?.split('T')[0] ?? 'N/A',
                    days: item?.contentId?.days,
                    nights: item?.contentId?.nights,
                    bookedSlots: item?.bookedSlots ?? 0,
                    totalSlots: item?.totalSlots ?? 0,
                    status: item?.status ?? '',
                    startCities: item?.contentId?.price?.map((city) => {
                        return {
                            city: city?.startCity,
                            price: city?.price
                        };
                    }),
                    difficulty: item?.contentId?.quickView?.difficulty
                };
            });
            setTableData(data);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
    }
};

export const getCustomTableData = async (
    selectedOrg,
    setTableData,
    limit,
    offset,
    selected,
    setLoading,
    datesType,
    trip = '',
    selectedDate = '',
    serviceType = 'trip'
) => {
    setLoading(true);
    try {
        const response = await orgBookings(
            selectedOrg,
            selected,
            limit,
            offset,
            trip,
            selectedDate,
            datesType,
            serviceType
        );
        setTableData(response.data || []);
    } catch (error) {
        errorHandle(error);
        setTableData([]); // Fallback to empty table
    } finally {
        setLoading(false);
    }
};
export const getKpiData = async (setKpiData, setLoading, orgid, serviceType) => {
    setLoading(true);
    try {
        const res = await supOrgTripDashStats(orgid, serviceType);
        const result = Object.entries(res.data).map(([name, count]) => ({
            name,
            count
        }));
        setKpiData(result);
    } catch (error) {
        console.error('Error fetching KPI data:', error);
    } finally {
        setLoading(false);
    }
};

export const dashboardCount = (orgId, selected, setTotalCount, setLoading) => {
    setLoading(true);
    try {
        orgDashboardCount(orgId, selected).then((res) => {
            setTotalCount(res.data.dashCount);
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const bookingCount = async (
    setTotalCount,
    setLoading,
    orgId,
    trip = '',
    selectedDate = '',
    selected,
    datesType,
    group,
    type
) => {
    setLoading(true);
    try {
        const res = await orgBookingsCount(orgId, trip, selectedDate, selected, datesType, group, type);
        setTotalCount(res.data.bookCount);
    } catch (error) {
        errorHandle(error);
    } finally {
        setLoading(false);
    }
};

export const fetchCompleteDashboardData = async (
    serviceType = 'act',
    selectedOrg,
    setTableData,
    setTotalCount,
    setKpiData,
    bookingsOnly,
    limit,
    offset,
    selected,
    setLoading,
    datesType,
    trip = '',
    selectedDate = ''
) => {
    setLoading(true);
    try {
        const response = await supOrgDashboardData(
            serviceType,
            selectedOrg,
            selected,
            bookingsOnly,
            limit,
            offset,
            selectedDate
        );
        setTableData(response.data.data);
        const result = Object.entries(response.data.stats).map(([name, count]) => ({
            name,
            count
        }));
        setKpiData(result);
        setTotalCount(response.data.totalCount);
    } catch (error) {
        errorHandle(error);
        setTableData([]); // Fallback to empty table
    } finally {
        setLoading(false);
    }
};
